function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLikeRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14H2v2h3v12H2v2h3a2 2 0 002-2V16a2 2 0 00-2-2zM28 23.172L23.172 28H13c-1.103 0-2-.897-2-2V14.829l.06-.06.054-.065 5.414-6.414.154-.182.107-.213L18.735 4h.657c.129.058.608.318.608 1v1c0 1.154-1.109 5.003-1.897 7.368L17.226 16H28v7.172zM28 14h-8s2-6 2-8V5c0-2-1.672-3-2.5-3H18c-.529 0-1 1-1 1l-2 4-5.414 6.414A2.001 2.001 0 009 14.829V26a4 4 0 004 4h10.172a2 2 0 001.414-.586l4.828-4.828A2 2 0 0030 23.172V16a2 2 0 00-2-2z",
    fill: props.color
  }));
}

export default SvgIconLikeRexOutline;